import { render, staticRenderFns } from "./KnProductOptionsType.vue?vue&type=template&id=47375196&"
import script from "./KnProductOptionsType.vue?vue&type=script&lang=js&"
export * from "./KnProductOptionsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports